import styled from 'styled-components';
import { launcherElementInfo } from '../../../../info/launcherElementInfo';
import { DropdownInput } from '../../baseInputs/DropdownInput';
import { useScene } from '../../../../context/sceneContext';

export const VariableTextVariableInput = () => {
  const scene = useScene();

  const data = scene.getSelectedElementsData({ variable: undefined }, 'props');

  const updateVariable = (value?: string) =>
    scene.updateSelectedElementsData({ variable: value }, 'props', 'variableTextVariableInput');

  const variablesInfo = launcherElementInfo.variableText.variables;
  const variableOptions = variablesInfo
    ? Object.keys(variablesInfo).map((command) => ({
        label: variablesInfo[command],
        value: command,
      }))
    : [];

  return (
    <Row>
      <DropdownInput
        label="Variable"
        value={data.variable}
        options={variableOptions}
        onChange={(newValue) => updateVariable(String(newValue))}
        canBeCleared={false}
      />
    </Row>
  );
};

const Row = styled.div`
  width: 100%;
  display: flex;
`;
